import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";

export const ChatbotPublicSlicer = createSlice({
  name: "ChatbotPublicSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    chatbotPublic: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearChatbotPublicStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  chatbotPublic,
  successChatbotPublic,
  failureChatbotPublic,
  clearChatbotPublicStatus,
} = ChatbotPublicSlicer.actions;

export default ChatbotPublicSlicer.reducer;
